import { restApiService } from '../../services/services';
import { axiosStorableError } from '../../util/errors';

export const SET_IS_MOBILE_SEARCH_FORM_VISIBLE = 'app/TransactionPage/SET_IS_MOBILE_SEARCH_FORM_VISIBLE';

export const PRE_HEADER_CONTENT_REQUEST = 'app/Topbar/PRE_HEADER_CONTENT_REQUEST';
export const PRE_HEADER_CONTENT_SUCCESS = 'app/Topbar/PRE_HEADER_CONTENT_SUCCESS';
export const PRE_HEADER_CONTENT_ERROR = 'app/Topbar/PRE_HEADER_CONTENT_ERROR';

// ================ Reducer ================ //

const initialState = {
  isMobileSearchFormVisible: false,
  preHeaderContent: null,
  preHeaderContentInProgress: false,
  preHeaderContentError: null,
};

export default function topbarReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_IS_MOBILE_SEARCH_FORM_VISIBLE:
      return { ...state, isMobileSearchFormVisible: payload };

    case PRE_HEADER_CONTENT_REQUEST:
      return {
        ...state,
        preHeaderContentInProgress: true,
      };
    case PRE_HEADER_CONTENT_SUCCESS:
      return {
        ...state,
        preHeaderContent: payload,
        preHeaderContentInProgress: false ,
      };
    case PRE_HEADER_CONTENT_ERROR:
      return {
        ...state,
        preHeaderContentError: payload,
        preHeaderContentInProgress: false,
      };

    default:
      return state;
  }
}

export const preHeaderContentRequest = () => ({
  type: PRE_HEADER_CONTENT_REQUEST,
});

export const preHeaderContentSuccess = payload => ({
  type: PRE_HEADER_CONTENT_SUCCESS,
  payload,
});

export const preHeaderContentError = e => ({
  type: PRE_HEADER_CONTENT_ERROR,
  payload: e,
});

// ================ Selectors ================ //

export const $isMobileSearchFormVisible = state => {
  return state.Topbar.isMobileSearchFormVisible;
};

export const $preHeaderContentState = state => {
  return {
    data: state.Topbar.preHeaderContent,
    inProgress: state.preHeaderContentInProgress,
    error: state.preHeaderContentError,
  };
}

// ================ Action creators ================ //
const setIsMobileSearchFormVisibleAction = value => ({
  type: SET_IS_MOBILE_SEARCH_FORM_VISIBLE,
  payload: value,
});

// ================ Thunks ================ //

export const showMobileSearchForm = () => dispatch => {
  dispatch(setIsMobileSearchFormVisibleAction(true));
};

export const hideMobileSearchForm = () => dispatch => {
  dispatch(setIsMobileSearchFormVisibleAction(false));
};

export const toggleMobileSearchForm = () => (dispatch, getState) => {
  const value = !$isMobileSearchFormVisible(getState());
  dispatch(setIsMobileSearchFormVisibleAction(value));
};

export const getPreHeaderContent = () => (dispatch, getState) => {
  dispatch(preHeaderContentRequest());

  return restApiService.publicInstance
    .get('/contentfulData/pre-header-content')
    .then(response => {
      dispatch(preHeaderContentSuccess(response));
    })
    .catch(e => {
      dispatch(preHeaderContentError(axiosStorableError(e)));
      throw e;
    })
  ;
}
